import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';
import { FeatureService } from '@app/shared/services/feature.service';
import { IframeCoordinatorClientService } from '@app/shared/services/iframe-coordinator-client.service';
import { EnvironmentHelperService } from '@shared/services/environment-helper.service';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';

/** Route guard that activates only if application is not iframed */
@Injectable({
  providedIn: 'root'
})
export class LandingGuard implements CanActivate {
  constructor(
    private readonly envHelperService: EnvironmentHelperService,
    private readonly feature: FeatureService,
    private readonly ifcClient: IframeCoordinatorClientService
  ) {
    /** constructor */
  }

  /**
   * Disallow this page if loaded within an iframe
   */
  public canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    if (this.envHelperService.isIframed) {
      if (this.envHelperService.isLocal) {
        return of(true);
      }

      return this.feature.hasFeature('adminUI.v3.IFC.migration').pipe(
        map((hasIfcFeature) => {
          if (hasIfcFeature) {
            this.ifcClient.navigate('/admin/welcomeV2', { transform: 'hostRelative' });
          } else {
            window.top.location.assign(
              `${window.top.location.origin + window.top.location.pathname}#/admin/welcomeV2`
            );
          }

          return false;
        })
      );
    }

    return of(true);
  }
}
